import { MasterL10nMessages } from '@sm/question-ui/respondent-survey';
import { defineMessages } from '@sm/intl';

/**
 * Copy used by SMQuestions - re-declaring the messages here allows translation into the
 * 56 languages needed by RespWeb (as opposed to the 16 in SMQuestions)
 */
export const COPY: MasterL10nMessages = defineMessages({
  QUESTION_TITLE: {
    id: 'QuestionFieldLayoutTemplate.QUESTION_TITLE',
    defaultMessage: 'Question Title',
    description: '[Type: Label][Vis: low] - question landmark for screen readers only',
  },
  NPS_QUESTION_TITLE: {
    id: 'Nps.QUESTION_TITLE',
    defaultMessage:
      '<div class="{srOnlyClass}">On a scale of {minValue} to {maxValue}, </div>{heading}<div id="{instructionsId}" class="{srOnlyClass}"> {minValue} for {minLabelText}, {maxValue} for {maxLabelText}</div>',
    description: '[Type: header][Vis: high] - question title',
  },
  OK_LABEL: {
    id: 'Button.OK_LABEL',
    defaultMessage: 'OK',
    description: '[Type: button][Vis: high] - question ok label',
  },
  PREVIOUS_MONTH: {
    id: 'CalendarPicker.previousMonth',
    defaultMessage: 'Previous Month',
    description: '[Type: button][Vis: high] - button label to go to previous month',
  },
  NEXT_MONTH: {
    id: 'CalendarPicker.nextMonth',
    defaultMessage: 'Next Month',
    description: '[Type: button][Vis: high] - button label to go to next month',
  },
  MONTH_SELECT: {
    id: 'CalendarPicker.month',
    defaultMessage: 'Select a month',
    description: '[Type: label][Vis: high] - label for month selection combo box',
  },
  YEAR_SELECT: {
    id: 'CalendarPicker.year',
    defaultMessage: 'Select a year',
    description: '[Type: label][Vis: high] - label for year selection combo box',
  },
  MONTHS: {
    id: 'CalendarPicker.months',
    defaultMessage:
      '{months, select, January {January} February {February} March {March} April {April} May {May} June {June} July {July} August {August} September {September} October {October} November {November} December {December}}',
    description: '[Type: label][Vis: high] - label for the months',
  },
  DAY_OF_WEEK_LEGEND_SHORT: {
    id: 'Month.dayOfWeekLegendShort',
    defaultMessage: '{dayOfTheWeek, select, Mo {Mo} Tu {Tu} We {We} Th {Th} Fr {Fr} Sa {Sa} Su {Su}}',
    description: '[Type: label][Vis: high] - label for the day of the week in shorthand',
  },
  DAY_OF_WEEK_LEGEND_FULL: {
    id: 'Month.dayOfWeekLegendLong',
    defaultMessage:
      '{dayOfTheWeek, select, Mo {Monday} Tu {Tuesday} We {Wednesday} Th {Thursday} Fr {Friday} Sa {Saturday} Su {Sunday}}',
    description: '[Type: label][Vis: high] - label for the day of the week',
  },
  DAY_OF_MONTH: {
    id: 'Day.dayOfMonth',
    defaultMessage: '{dayInCalendar, date, full}',
    description: '[Type: label][Vis: high] - label for the full date',
  },
  DATE_INTL_FORMAT_ERROR: {
    id: 'DateTime.dateIntlFormatError',
    defaultMessage: 'Please provide date in DD/MM/YYYY format.',
    description:
      '[Type: label][Vis: high] - label for incorrect or missing date error (using ISO 8601 US date character format notation)',
  },
  DATE_US_FORMAT_ERROR: {
    id: 'DateTime.dateUsFormatError',
    defaultMessage: 'Please provide date in MM/DD/YYYY format.',
    description:
      '[Type: label][Vis: high] - label for incorrect or missing date error (using ISO 8601 international date character format notation)',
  },
  ERROR_ENTER_HOURS: {
    id: 'DateTime.errorEnterHours',
    defaultMessage: 'Please enter hours from 0 to 12.',
    description: '[Type: label][Vis: high] - label for incorrect or missing hour input',
  },
  ERROR_ENTER_MINUTES: {
    id: 'DateTime.errorEnterMinutes',
    defaultMessage: 'Please enter minutes from 0 to 59.',
    description: '[Type: label][Vis: high] - label for incorrect or missing minute input',
  },
  ERROR_SELECT_PERIOD: {
    id: 'DateTime.errorSelectPeriod',
    defaultMessage: 'Please select AM/PM.',
    description: '[Type: label][Vis: high] - label for incorrect or missing period selection',
  },
  ARIA_RANK_MOVED_UP: {
    id: 'Ranking.AriaRankMovedUp',
    defaultMessage: '{label} moved up to number {position}',
    description: '[Type: button][Vis: high] - accessible ranking moved up label',
  },
  ARIA_RANK_MOVED_DOWN: {
    id: 'Ranking.AriaRankMovedDown',
    defaultMessage: '{label} moved down to number {position}',
    description: '[Type: button][Vis: high] - accessible ranking moved down label',
  },
  ARIA_RANK_MOVED_TO_TOP: {
    id: 'Ranking.AriaRankAtTop',
    defaultMessage: '{label} moved to the top of the list',
    description: '[Type: button][Vis: high] - accessible ranking at top of list',
  },
  ARIA_RANK_MOVED_TO_BOTTOM: {
    id: 'Ranking.AriaRankAtBottom',
    defaultMessage: '{label} moved to the bottom of the list',
    description: '[Type: button][Vis: high] - accessible ranking at bottom of list',
  },
});

export default COPY;
